module.exports = __webpack_public_path__ + "static/media/Sentek.3b25e543.jpg";